export default {
  title: "Tariflar",
  tariff: "Tarif",
  yourTariff: "Sizning tarifingiz",
  lessTariffModal: {
    title: "Sizning tarifingizda sovg‘a kartalarini chiqarish mumkin emas",
    subtitle:
      "Sovg‘a kartalarni chiqarish uchun «Promo» yoki «Pro+» tarifiga o‘ting",
  },
  lite_p: {
    title: "Light",
    list: [
      '<span itemprop="name">1 ta yuridik shaxsni ro‘yxatdan o‘tkazish',
      '<span itemprop="name">5 ta savdo nuqtasini yaratish',
      '<span itemprop="name">Soddalashtirilgan statistika',
      '<span itemprop="name">RC KASSA ga kirish',
      '<span itemprop="name">Elektron hujjat aylanmasi',
      '<span itemprop="name">Hisob-kitoblar oyiga 2 marta',
      '<span itemprop="name">Savol-javob bo‘limi',
    ],
  },
  promo_p: {
    title: "Promo",
  },

  pluspro_p: {
    title: "Pro+",
  },
  faq: [
    {
      title: "Mijozni raqamlashtirish qanday amalga oshiriladi?",
      text:
        "<p>Mijozni raqamlashtirish uchun unga promokod berishingiz kerak. Bu referal havola, QR-kod yoki raqamlashtirish kodi shaklida bo‘lishi mumkin. Kod yordamida mijoz rcpay.ru klient xizmatida ro‘yxatdan o‘tishi kerak.</p>" +
        "<br>" +
        "<p>Diqqat: QR-kodni o‘qish uchun mijozga mos funksiyaga ega kamera yoki QR-kod o‘qish uchun maxsus ilova kerak bo‘ladi.</p>",
    },
    {
      title: "“Faol” mijoz nima degani?",
      text:
        "<p>Bu siz tomonidan raqamlashtirilgan mijoz bo‘lib, RC Group ekotizimidagi onlayn yoki oflayn savdo nuqtasida xarid qilgan. Onlayn xaridlar: RC Marketda xarid, sertifikat sotib olish, Yandex xizmatlarini faollashtirish, foydalanuvchi tarifini xarid qilish. Oflayn xaridlar: shahar ichidagi RC Kassa orqali savdo nuqtalarida xarid.</p>" +
        "<br>" +
        "<p>«Korporativ» tarifini xarid qilganda har bir hamkor «50% chegirma» aksiyasida qatnashadi. Aksiyaning asosiy sharti – 500 dan ortiq «faol» mijozni raqamlashtirish.</p>",
    },
    {
      title: "Agar tarifni yangilamasam nima bo‘ladi?",
      text: "<p>Bunda kabinet funksiyalari «Basic» tarif darajasiga tushadi. Faqat «Mijozlar ro‘yxati» bo‘limiga kirish qoladi, Wallet kartalarini chiqarish, Push-xabarnomalarni jo‘natish va «Naqd bo‘lmagan tip» xizmatiga kirish imkoniyati yo‘qoladi.</p>",
    },
    {
      title: "Qanday qilib ko‘proq mijozni jalb qilib raqamlashtirish mumkin?",
      text: "<p>«Ulashish» funksiyasidan foydalanib, referal havolani ijtimoiy tarmoqlarda joylashtiring. Shuningdek, savdo nuqtangizda table-tentlar, stikerlar, varaqalar va woblerlarni joylashtiring.</p>",
    },
    {
      title: "Savolim yo‘q, javobni qanday olish mumkin?",
      text:
        "<p>Texnik yordamga murojaat qiling. Buning uchun o‘ng past burchakdagi RC Group ikonkasini bosing, «Telegram»ni tanlang va muammoingizni yozing, kerak bo‘lsa skrinshotlarni ilova qiling. Mutaxassisimiz siz bilan bog‘lanadi va muammoni tezkor hal qiladi.</p>" +
        "<br>" +
        "<p>Shuningdek, emailga yuborish mumkin: <a href='mailto:hello@rc.company'>hello@rc.company</a> </br>" +
        "<br>" +
        "Yoki telefon orqali qo‘ng‘iroq qiling: <b>8 (800) 500-57-62.</b></p>",
    },
  ],
  digitizedClientsCounter: "Raqamlashtirilgan mijozlar soni",
  activeClientsDigitized: "Raqamlashtirilgan faol mijozlar",
  reg500AndMoreClients:
    "50% chegirma olish uchun sadoqat dasturiga 500 va undan ortiq <b>faol mijozlarni</b> ro‘yxatdan o‘tkazing",
  choosePointToGenerateQr:
    "RC PAY’da yangi mijozlarni ro‘yxatdan o‘tkazish uchun havola va QR-kod yaratish uchun savdo nuqtasini tanlang.",
  afterBuyTariffYouCanGenerate:
    "Tarifni xarid qilgandan so‘ng RC PAY’da yangi mijozlarni ro‘yxatdan o‘tkazish uchun havola va QR-kod yaratish mumkin bo‘ladi.",
  useLinkAndQrForRegNewClients:
    "Yangi mijozlarni RC PAY’da ro‘yxatdan o‘tkazish uchun havola va QR-koddan foydalaning.",
  shareLink: "Havolani ulashish",
  anyOtherQuestions: "Boshqa savollar bormi?",
  tariffSuccessPayed: "«{tariff}» tarifi muvaffaqiyatli to‘landi",
  tariffPayFromMainEntity:
    "Tarif to‘lovi asosiy yuridik shaxs balansidan amalga oshiriladi.<br />",
  period: "Davr",
  cost: "Narxi",
  discount: "{discount}% chegirma",
  totalToPay: "Jami to‘lov",
  lite: "Light",
  promo: "Promo",
  plusPro: "Pro+",
  basic: "Basic",
  corporate: "Korporativ",
  popular: "Mashhur",
  advanced: "Kengaytirilgan",
  includesToTariff: "Tarifga kiradi",
  allInLitePlus: "Light tarifidagi barcha, qo‘shimcha",
  allInPromoPlus: "Promo tarifidagi barcha",
  allInBasicPlus: "Basic tarifidagi barcha, qo‘shimcha",
  forFree: "Bepul",
  buyTariff: "Tarifni sotib olish",
  tradingPoints: "savdo nuqtalari",
  products: "Mahsulotlar",
  unlimitProducts: "Cheksiz mahsulotlar",
  uCanAddProductsToEMenu:
    "Onlayn katalogga {productsCount} ta mahsulot qo‘shish va RC PAY orqali onlayn buyurtmalar olish mumkin",
  canAddUnlimitProductsToEMenu:
    "Onlayn katalogga cheksiz mahsulot qo‘shish va RC PAY orqali onlayn buyurtmalar olish mumkin",
  twoTgMailingPerWeek: "Haftasiga 2 marta Telegram jo‘natish",
  oneTgMailingPerDay: "Kuniga 1 marta Telegram jo‘natish",
  canCreateAndSend2NotifyPerWeek:
    "Har bir savdo nuxtasidagi mijozlarga haftasiga 2 xabar yuborish mumkin",
  canCreateAndSend1NotifyPerDay:
    "Har bir savdo nuxtasidagi mijozlarga kuniga 1 xabar yuborish mumkin",
  basicAnalytics: "Asosiy tahlil",
  analyticsHint: "Savdo nuqtalari va yuridik shaxslar bo‘yicha tahlil",
  accrualDeducationPoints: "RC KASSA’da ballarni hisoblash va yechish",
  enablingPaymentMethods: "To‘lov usullarini ulash",
  postingYourShopsInRC: "Savdo nuqtalaringizni RC PAY’da joylashtirish",
  postingYourShopsHint:
    "RC PAY joylashtirish qoidalariga mos bo‘lsa<br><br><a target='_blank' href='/docs/Правила размещения.pdf'>RC PAY joylashtirish qoidalari</a>",
  gettingOnlineOrders: "Mahsulot/xizmatlarga onlayn buyurtmalar olish",
  orderPromotionYourShops: "Savdo nuqtalaringizni rivojlantirish buyurtmasi",
  advancedAnalytics: "Kengaytirilgan tahlil",
  advancedAnalyticsHint:
    "Savdo nuqtalari, yuridik shaxslar, kassirlar, mijozlar va RFM tahlil",
  evaluationCashierWork: "Kassir ishini baholash",
  digitizingClients: "Mijozlarni raqamlashtirish",
  accessToClientsList: "Mijozlar ro‘yxatiga kirish",
  infoAboutAllClients:
    "Savdo nuqtangizga tashrif buyurgan barcha mijozlar haqida ma’lumot, ularning kontaktlari, cheklar va statistika",
  pushNotifyToClientWalletCard: "Wallet kartasiga push-xabarnomalar",
  scoringPointsByGroups: "Mijozlar guruhlari bo‘yicha ballarni hisoblash",
  uCanSetDifferentPercentAward:
    "Xarid summasiga qarab turli mukofot foizlarini belgilash mumkin",
  distributionRCCard: "RC kartalarini tarqatish",
  designWalletCard: "Wallet kartasi dizayni",
  issuingGiftCard: "Sovg‘a kartalarini chiqarish",
  priorityMaintenance: "Ustuvor xizmat",
  monetizationUpTo30Percent:
    "Mijozga hisoblangan mukofotdan 30% gacha monetizatsiya",
  monetizationHint:
    "Agar siz sadoqat dasturidan daromad olish imkoniyatiga ega bo‘lsangiz va bu faoliyat sizning tashkilotingiz uchun yaratilgan bo‘lsa",
  adding1Entity: "1 ta yuridik shaxs qo‘shish",
  accessToOperationsHistory: "Operatsiyalar tarixiga kirish",
  basicCabinetFunctional: "Kabinetning asosiy funksionalligi",
  discountOnTariffRenewal: "Tarifni yangilashda 50% chegirma",
  discountOnTariffRenewalHint:
    "50% chegirma oxirgi tarif xarididan so‘ng 500 va undan ortiq faol mijoz raqamlashtirilsa beriladi<br><br><a href='#clients-counter'>Mijozlar hisoblagichini ko‘ring</a>",
  autoConnectIfFreeTariff:
    "Agar pullik tarif xarid qilinmagan bo‘lsa, avtomatik ulanadi.",
  tariffBuyingWillAvailableFromDate:
    "{date} dan tarif sotib olish mumkin bo‘ladi",
  entityOnModeration: "Yuridik shaxs moderatsiyada",
  tariffBuyingWillAvailableAfterModeration:
    "Yuridik shaxs moderatsiyani o‘tkazgandan so‘ng tarifni sotib olish mumkin bo‘ladi.",
  notEnoughMoney: "Mablag‘ yetarli emas",
  tariffPayingFromFactBalance:
    "Tarif to‘lovi asosiy yuridik shaxs balansidan amalga oshiriladi.",
  forBuyingTariffNeedReplenish:
    "«{tariff}» tarifini sotib olish uchun {entity} balansini kamida {sum} ₽ ga to‘ldirish kerak",
  replenishBalance: "Balansni to‘ldirish",
  canCreate: "Yaratish mumkin",
  forTransitionToTariffConnectWithUs:
    "Pullik tarifga o‘tish uchun texnik yordamga murojaat qiling",
  paidBefore: "To‘lov muddati",
};
